module.exports = function () {
    'use strict';
    if (typeof Number.isFinite !== 'function') {
        Number.isFinite = function isFinite(value) {
            if (typeof value !== 'number') {
                return false;
            }
            if (value !== value || value === Infinity || value === -Infinity) {
                return false;
            }
            return true;
        };
    }
    function zeroPad(number, precision) {
        number = number.toString();
        while (number.length < precision) {
            number = '0' + number;
        }
        return number;
    }
    return {
        formatTime: function (time, precision) {
            var result = [];
            var fractionSeconds = Math.floor(time % 1 * Math.pow(10, precision));
            var seconds = Math.floor(time);
            var minutes = Math.floor(seconds / 60);
            var hours = Math.floor(minutes / 60);
            if (hours > 0) {
                result.push(hours);
            }
            result.push(minutes % 60);
            result.push(seconds % 60);
            for (var i = 0; i < result.length; i++) {
                result[i] = zeroPad(result[i], 2);
            }
            result = result.join(':');
            if (precision > 0) {
                result += '.' + zeroPad(fractionSeconds, precision);
            }
            return result;
        },
        roundUpToNearest: function (value, multiple) {
            if (multiple === 0) {
                return 0;
            }
            var multiplier = 1;
            if (value < 0) {
                multiplier = -1;
                value = -value;
            }
            var roundedUp = Math.ceil(value);
            return multiplier * ((roundedUp + multiple - 1) / multiple | 0) * multiple;
        },
        clamp: function (value, min, max) {
            if (value < min) {
                return min;
            } else if (value > max) {
                return max;
            } else {
                return value;
            }
        },
        extend: function (to, from) {
            for (var key in from) {
                if (this.objectHasProperty(from, key)) {
                    to[key] = from[key];
                }
            }
            return to;
        },
        isInAscendingOrder: function (array) {
            if (array.length === 0) {
                return true;
            }
            var value = array[0];
            for (var i = 1; i < array.length; i++) {
                if (value >= array[i]) {
                    return false;
                }
                value = array[i];
            }
            return true;
        },
        isNumber: function (value) {
            return typeof value === 'number';
        },
        isValidTime: function (value) {
            return typeof value === 'number' && Number.isFinite(value);
        },
        isObject: function (value) {
            return value !== null && typeof value === 'object' && !Array.isArray(value);
        },
        isString: function (value) {
            return typeof value === 'string';
        },
        isArrayBuffer: function (value) {
            return Object.prototype.toString.call(value).includes('ArrayBuffer');
        },
        isNullOrUndefined: function (value) {
            return value === undefined || value === null;
        },
        isFunction: function (value) {
            return typeof value === 'function';
        },
        isBoolean: function (value) {
            return value === true || value === false;
        },
        isHTMLElement: function (value) {
            return value instanceof HTMLElement;
        },
        isArray: function (value) {
            return Array.isArray(value);
        },
        isLinearGradientColor: function (value) {
            return this.isObject(value) && this.objectHasProperty(value, 'linearGradientStart') && this.objectHasProperty(value, 'linearGradientEnd') && this.objectHasProperty(value, 'linearGradientColorStops') && this.isNumber(value.linearGradientStart) && this.isNumber(value.linearGradientEnd) && this.isArray(value.linearGradientColorStops) && value.linearGradientColorStops.length === 2;
        },
        objectHasProperty: function (object, field) {
            return Object.prototype.hasOwnProperty.call(object, field);
        }
    };
}();